exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/compound-assessments.js-WebpackMultiOutput";